import { ICanvasElement } from '@/interface/canvas';

export const getScreenElementStyle = (
  element: ICanvasElement,
  defaultStyle?: ICanvasElement
) => {
  const height =
    element?.height != undefined ? element?.height : defaultStyle?.height || 50;
  const width =
    element?.width != undefined ? element?.width : defaultStyle?.width || 300;
  const rotation = element?.rotation ? element?.rotation : 0;
  const xElePosition = element?.position?.[0];
  const defaultXPosition = defaultStyle?.position?.[0] || 40;
  const yElePosition = element?.position?.[1];
  const defaultYPosition = defaultStyle?.position?.[1] || 520;
  const x = xElePosition != undefined ? xElePosition : defaultXPosition;
  const y = yElePosition != undefined ? yElePosition : defaultYPosition || 520;
  const borderRadius =
    element?.border_radius != undefined
      ? element?.border_radius
      : defaultStyle?.border_radius || '0px';
  const backgroundColor =
    element?.background_color != undefined
      ? element?.background_color
      : defaultStyle?.background_color || 'transparent';
  const borderWidth =
    element?.border_width != undefined
      ? element?.border_width
      : defaultStyle?.border_width || '#000000';
  const borderStyle =
    element?.border_style != undefined
      ? element?.border_style
      : defaultStyle?.border_style;
  const borderColor =
    element?.border_color != undefined
      ? element?.border_color
      : defaultStyle?.border_color;
  const style: any = {
    ...element,
    position: 'absolute',
    top: y,
    left: x,
    transform: `rotate(${rotation}deg)`,
    height: height,
    width: width,
    backgroundColor,
    borderRadius,
    borderWidth,
    borderStyle,
    borderColor,
  };
  return style;
};
